import { request } from '../../utils/request';

export const signOut = (req: { authToken: string; refreshToken: string }) => {
  return request({
    method: 'POST',
    url: '/auth/logout',
    headers: {
      Authorization: `Bearer ${req.authToken}`,
    },
    formData: {
      refreshToken: req.refreshToken,
    },
    callback: undefined,
    onError: (err) => {
      throw err;
    },
  });
};
